<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Leads list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewLeads()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="status-box item">
            <label for="paginate" class="mb-0">BDM</label>
            <select
              v-model="selectedBDM"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All BDM</option>
              <option
                v-for="item in getBDMTeamMember"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option
                v-for="item in optionLeadsAndQuoteStatus"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>

          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableLeadsList">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>
                <th class="header-item v-th-80">
                  <a href="#" @click.prevent="fnChangeSort('id')">Leads Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-80">Quote Id</th>
                <th class="header-item">Source</th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('rp_name')"
                    >Referral</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'rp_name'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'rp_name'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-5">Source URL</th>

                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('client')"
                    >Client Name</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'client'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'client'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Phone</th>
                <th class="header-item">Make</th>
                <th class="header-item">Model</th>
                <th class="header-item v-th-90">
                  <a href="#" @click.prevent="fnChangeSort('created_at')"
                    >Created</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'created_at'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'created_at'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-90">Next followup</th>
                <th class="header-item">BDM/Sent by</th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(quote, index) in getLeadsPaginateData.data">
                <tr :key="(quote, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td>{{ quote.id }}</td>
                  <td>{{ quote.id_quote }}</td>
                  <td>{{ quote.leadSource }}</td>

                  <td class="column-1">
                    <span v-if="quote.leadSource != 'RDL'">{{
                      quote.rp_name
                    }}</span
                    ><span v-if="quote.leadSource == 'RDL'">{{
                      quote.refer_dealer_name
                    }}</span>
                  </td>
                  <td class="column-1">
                    <WDExpandDetailCell
                      :rowId="quote.id"
                      :content="quote.sourceUrl"
                      @fnSelectRow="fnSetActiveRow(quote.id)"
                      @fnCloseExpand="fnCloseExpand"
                      :activeRow="activeRow"
                      :numberOfCharLimit="15"
                    ></WDExpandDetailCell>
                  </td>

                  <td class="column-2">
                    <span
                      >{{ quote.client_first_name }}
                      {{ quote.client_last_name }} |
                      <span class="text-black-60 fs-600">
                        {{ quote.hAddressState }}</span
                      ></span
                    >
                    <br />
                    <span class="text-black-60 fs-600">{{
                      quote.employerName
                    }}</span>
                  </td>
                  <td>
                    {{ quote.client_mobile_number }}
                  </td>
                  <td>
                    {{ quote.make }}
                  </td>
                  <td>
                    {{ quote.model }}
                  </td>
                  <td>
                    {{ quote.created_at | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ quote.nextFollowupDate | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ quote.createdBy }}
                  </td>
                  <td class="v-td-center">
                    <div v-if="quote.status_quote != ''">
                      <WDQuoteStatusBadge
                        :status="quote.status_quote"
                      ></WDQuoteStatusBadge>
                    </div>
                    <div v-else>
                      <WDLeadsStatusBadge
                        :status="quote.status"
                      ></WDLeadsStatusBadge>
                    </div>
                  </td>
                  <td class="v-td-center">
                    <div class="d-flex">
                      <div>
                        <span v-if="quote.status != 21">
                          <a
                            @click="fnGoViewQuote(quote.id)"
                            v-b-tooltip.hover
                            title="View quote"
                            class="d-inline pr-2"
                            ><i class="far fa-eye text-primary fs-1000"></i
                          ></a>
                        </span>
                        <span v-else>
                          <i
                            class="
                              las
                              la-hand-paper
                              d-inline
                              pr-2
                              text-primary
                              fs-1200
                            "
                          ></i>
                        </span>
                      </div>

                      <a
                        @click="fnGoEditQuote(quote.id)"
                        v-b-tooltip.hover
                        title="Update quote"
                        class="d-inline pr-2"
                        ><i class="far fa-edit text-primary fs-1000"></i
                      ></a>

                      <appModalNextFollowup
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      ></appModalNextFollowup>
                      <appModalLeadsMsgVSA
                        :quoteId="quote.id"
                        :quote="quote"
                        class="d-inline pr-2"
                      ></appModalLeadsMsgVSA>
                      <modalLeadsStatusUpdate
                        :row="quote"
                        @fnRefresh="fnReload()"
                        class="d-inline pr-2"
                      ></modalLeadsStatusUpdate>
                      <appModalLeadsArchive
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      >
                      </appModalLeadsArchive>
                      <appModalLeadsTransfer
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      ></appModalLeadsTransfer>
                    </div>
                  </td>
                </tr>

                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="17">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-6 col-md-6 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Updated</dt>
                          <dd class="col-sm-7">
                            <span v-if="quote.updated_at != null">{{
                              quote.updated_at | dateConvertDDMMYYYYTime
                            }}</span>
                            <span v-else></span>
                          </dd>
                          <dt class="col-sm-5">Email</dt>
                          <dd class="col-sm-7">
                            {{ quote.client_email }}
                          </dd>
                          <dt class="col-sm-5">Pricing Document</dt>
                          <dd class="col-sm-7" v-if="quote.pricingDocumentUrl">
                            <a
                              class="text-primary fw-600"
                              :href="quote.pricingDocumentUrl"
                              target="_blank"
                              >View document</a
                            >
                          </dd>
                        </dl>
                        <!-- List of  application notes-->
                        <dl class="row" v-if="quote && quote.notes">
                          <dt class="col-sm-12">Application Notes</dt>
                          <dd class="col-sm-12">
                            <div>
                              <b-card-text
                                v-html="quote.notes.applicationNotes"
                              ></b-card-text>
                            </div>
                          </dd>
                        </dl>
                        <!-- List of Leads Notes -->
                        <WDVsaLeadsNotes
                          v-if="quote.leadsNote.length"
                          :leadsNote="quote.leadsNote"
                        ></WDVsaLeadsNotes>
                      </div>

                      <div class="col-lg-6 col-md-6 col-12">
                        <!-- VSA quotes and leads logs -->
                        <WDVsaQuoteLeadsLogs
                          v-if="quote.vsa_logs.length"
                          :vsaLogs="quote.vsa_logs"
                        ></WDVsaQuoteLeadsLogs>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="17">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getLeadsPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { optionLeadsAndQuoteStatus } from '../../../services/data.service'
import pagination from 'laravel-vue-pagination'
import * as authService from '../../../services/auth.service'
import * as taxTableService from '../../../services/taxTable.service'
import appModalLeadsMsgVSA from '../../../components/leads/ModalLeadsMsgVSA.vue'
import appModalLeadsArchive from '../../../components/leads/ModalLeadsArchive.vue'
import appModalNextFollowup from '../../../components/leads/ModalNextFollowup.vue'
import appModalLeadsTransfer from '../../../components/admin/ModalLeadsTransfer.vue'
import WDQuoteStatusBadge from '../../../components/wd/WDQuoteStatusBadge.vue'
import WDLeadsStatusBadge from '../../../components/wd/WDLeadsStatusBadge.vue'
import WDVsaLeadsNotes from '../../../components/wd/WDVsaLeadsNotes.vue'
import WDExpandDetailCell from '../../../components/wd/WDExpandDetailCell.vue'
import modalLeadsStatusUpdate from '../../../components/admin/ModalLeadsStatusUpdate.vue'

export default {
  name: 'bdmLeadsList',
  components: {
    pagination,
    appModalLeadsMsgVSA,
    appModalLeadsArchive,
    appModalLeadsTransfer,
    appModalNextFollowup,
    WDQuoteStatusBadge,
    WDLeadsStatusBadge,
    WDVsaLeadsNotes,
    WDExpandDetailCell,
    modalLeadsStatusUpdate
  },
  data() {
    return {
      isDataFetch: true,
      optionLeadsAndQuoteStatus: optionLeadsAndQuoteStatus,
      activeRow: -1,
      loginUserObj: {},
      selectedBDM: '',
      opened: [],
      userId: '',
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id',
      paginate: {
        userId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedBDM: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters(['getLeadsSingle', 'getLeadsPaginateData', 'getUserById']),
    getBDMTeamMember() {
      return this.getUserById.bdm_users ?? []
    }
  },
  methods: {
    ...mapActions(['fetchLeadsSingle', 'fetchLeadsPaginate', 'fetchUserById']),

    fnGoNewLeads() {
      this.$router.push({ name: 'bdm.LeadsNew' })
    },

    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGoViewQuote(id) {
      this.$router.push({
        name: 'bdm.leadsView',
        params: { quoteId: id }
      })
    },
    fnGoEditQuote(id) {
      this.$router.push({ name: 'bdm.leadsEdit', params: { quoteId: id } })
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        userId: this.userId,
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchLeadsPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        userId: this.userId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchLeadsPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        userId: this.userId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchLeadsPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        userId: this.userId,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchLeadsPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        userId: this.userId,
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedBDM: this.selectedBDM,
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchLeadsPaginate(objNew)
    },
    /**
     * After update Leads status need to call fnGetQuoteList
     * For Refresh data in listing
     */
    fnReload() {
      this.fnGetQuoteList()
    },

    fnSetActiveRow(rowId) {
      this.activeRow = rowId
      return
    },
    fnCloseExpand() {
      this.activeRow = -1
      return
    }
  },
  created() {
    this.loginUserObj = authService.getUserFromToken()
    this.userId = this.loginUserObj.id
    this.fetchUserById(this.userId)

    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      userId: this.userId,
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedBDM: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchLeadsPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
